import { Mixpanel } from '../init';

export const businessPageViewEvent = () => {
   Mixpanel.track('Business Page - Page View');
};

export const businessTopRegisterBtnEvent = () => {
   Mixpanel.track('Business Page - Top Sign Up Btn');
};

export const businessTopRequestBtnEvent = () => {
   Mixpanel.track('Business Page - Top Request Call Btn');
};

export const homepageCategoryBtnEvent = (category: string) => {
   Mixpanel.track('Business Page - Category Sign Up Btn', {
      category,
   });
};

export const businessResellerStartBtnEvent = () => {
   Mixpanel.track('Business Page - Reseller Start Now Btn');
};

export const businessBottomRegisterBtnEvent = () => {
   Mixpanel.track('Business Page - Bottom Sign Up Btn');
};

export const businessBottomRequestBtnEvent = ({ name, email, mobile, business_name }: any) => {
   Mixpanel.track('Business Page - Bottom Request Call Btn', {
      name,
      email,
      mobile,
      business_name,
   });
};

export const businessRequestCallSuccessEvent = ({ name, email, mobile, business_name }: any) => {
   Mixpanel.track('Business Page - Request Call Btn Success', {
      name,
      email,
      mobile,
      business_name,
   });
};

export const businessRequestCallFailureEvent = ({ name, email, mobile, business_name }: any) => {
   Mixpanel.track('Business Page - Request Call Btn Failed', {
      name,
      email,
      mobile,
      business_name,
   });
};
